import type { ListenerEffectAPI } from "@reduxjs/toolkit";
import type {
  AddStorageObjectFulfilled,
  EditStorageObjectFulfilled,
} from "../../../../../app/state/storageObjectSlice/types";
import type { AppDispatch, RootState } from "../../../types";
import { DefaultService } from "./defaultHandler";
import { DialogsService } from "./dialogHandler";
import { ResearchService } from "./researchHandler";
import { AssistantService } from "./assistantHandlers";
import { PracticumService } from "./practicumHandlers";
import { CasesService } from "./casesHandlers";
import { MeetingsService } from "./meetingsHandler";
import {
  StorageObjectValue,
  StorageScope,
} from "../../../../api/instances/storageApi/types/service_types";
import { FilesService } from "./filesHandlers";
import { NormalizedStorageObject } from "../../../../api/instances/storageApi/types/object_types";
import { SkillsService } from "./skillsHandlers";
import { chatbotService } from "./chatbotHandlers";
import { SpaService } from "./spaHandlers";
import { AgentService } from "./agentHandlers";
import { ExtraAppService } from "./extraAppHandlers";
import { SchemasService } from "./schemasHandler";

export type ServiceHandler = {
  onCreate?: (
    listenerApi: ListenerEffectAPI<RootState, AppDispatch>,
    normalized: NormalizedStorageObject<StorageObjectValue>,
    meta: AddStorageObjectFulfilled["meta"],
  ) => Promise<void>;
  onUpdate?: (
    listenerApi: ListenerEffectAPI<RootState, AppDispatch>,
    id: string,
    value: StorageObjectValue,
    meta: EditStorageObjectFulfilled["meta"],
  ) => Promise<void>;
  onSelect?: (
    listenerApi: ListenerEffectAPI<RootState, AppDispatch>,
    id: string | null,
    value: StorageObjectValue,
    extraOption?: unknown,
  ) => Promise<void>;
  onDelete?: (
    listenerApi: ListenerEffectAPI<RootState, AppDispatch>,
    id: string,
    value: StorageObjectValue,
  ) => Promise<void>;
  onLeave?: (
    listenerApi: ListenerEffectAPI<RootState, AppDispatch>,
  ) => Promise<void>;
  onSelectVersion?: (
    listenerApi: ListenerEffectAPI<RootState, AppDispatch>,
    id: string | null,
    value: StorageObjectValue,
    extraOption?: unknown,
  ) => Promise<void>;
};

export const serviceHandlers: Record<StorageScope, ServiceHandler> = {
  krab: AgentService,
  ai_agents_extra_app: ExtraAppService,
  ai_agents_spa: SpaService,
  ai_agents_telegram_bots: chatbotService,
  assistants: AssistantService,
  cases: CasesService,
  classify: DefaultService,
  dialogs: DialogsService,
  knowledge_base: DefaultService,
  llm_compare: DefaultService,
  practicum: PracticumService,
  meetings: MeetingsService,
  research: ResearchService,
  userfiles: FilesService,
  schemas: SchemasService,
  stylizator: DefaultService,
  skills: SkillsService,
  usersettings: DefaultService,
};
